import { gql } from '@apollo/client';

export const FETCH_PRODUCT_GROUPS = gql`
  query GetProductGroups {
    getAllProductGroup {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const CREATE_PRODUCT_GROUP = gql`
  mutation productGroup($data: CreateProductGroupFinancialInput!) {
    createProductGroup(input: $data) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const EDIT_PRODUCT_GROUP = gql`
  mutation productGroup($data: UpdateProductGroupFinancialInput!) {
    updateProductGroup(input: $data) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const DELETE_PRODUCT_GROUP = gql`
  mutation productGroupRemove($uuid: String!) {
    deleteProductGroup(uuid: $uuid) {
      costOfSales
      grossMargin
      name
      revenue
      uuid
    }
  }
`;

export const FETCH_PRODUCT_GROUP_BY_DIVISION = gql`
  query GetProductGroupByDivision($uuid: String!) {
    getAllProductGroupsByDivision(uuid: $uuid) {
      costOfSales
      grossMargin
      isDefault
      name
      percentage
      revenue
      uuid
    }
  }
`;
